import ChevronRight from "@assets/svg/ChevronRight";
import * as Sentry from "@sentry/react-native";
import ToastMessage from "@components/Toast";
import { actions as delayedActions } from "@reducers/delayDataReducer";
import { postCpAvailability } from "@services/api/CpAvailability";
import React, { useState } from "react";
import {
  LayoutAnimation,
  Pressable,
  StyleSheet,
  Text,
  View,
} from "react-native";
import { useDispatch } from "react-redux";
import analytics from "../analytics";
import ModalView from "./ModalView";

const Chevron = ({ direction }) => (
  <View
    style={{
      height: 14,
      width: 8,
      borderColor: "white",
      borderWidth: 0,
      alignSelf: "center",
    }}
  >
    {direction === "right" ? (
      <ChevronRight height={14} />
    ) : (
      <ChevronRight height={14} style={{ transform: [{ rotate: "180deg" }] }} />
    )}
  </View>
);

const ChipView = ({
  open,
  setOpen,
  expandedBgColor,
  expandedText,
  expandedTextColor,
  chipModal,
}) => {
  const {
    icon,
    title,
    body,
    cta_left_key: ctaLeftKey,
    cta_left_text: ctaLeftText,
    cta_left_text_color: ctaLeftTextColor,
    cta_left_bg_color: ctaLeftBgColor,
    cta_right_key: ctaRightKey,
    cta_right_text: ctaRightText,
    cta_right_text_color: ctaRightTextColor,
    cta_right_bg_color: ctaRightBgColor,
    cta_left_success_text: ctaLeftSuccessText,
    cta_right_success_text: ctaRightSuccessText,
  } = chipModal || {};

  const [showChipModal, setShowChipModal] = useState(null);
  const dispatch = useDispatch();

  const handleModalResponse = (resp) => () => {
    if (resp === "NO" || resp === "YES") {
      postCpAvailability({ response: resp })
        .then(({ data }) => {
          const toastMessage =
            resp === ctaRightKey ? ctaRightSuccessText : ctaLeftSuccessText;
          if (toastMessage) {
            ToastMessage("simple", toastMessage, 3000, "bottom");
          }
          dispatch(delayedActions.updateCpAvailabilityModal(data));
        })
        .catch((e) => {
          Sentry.captureException(e);
          dispatch(delayedActions.updateCpAvailabilityModal({}));
        });
    }
    analytics.modalAction({
      title: chipModal.title,
      cta: resp,
      source: "chip",
    });
    setShowChipModal(false);
  };

  const handleChipViewPress = () => {
    if (open === false && chipModal && chipModal.title) {
      setShowChipModal(true);
    }
    LayoutAnimation.configureNext(LayoutAnimation.Presets.easeInEaseOut);
    analytics.chipClicked({ visible: showChipModal, title: chipModal.title });
    setOpen((prevState) => !prevState);
  };

  return (
    <>
      <ModalView
        isChipModal
        visible={showChipModal}
        icon={icon}
        title={title}
        body={body}
        _onPress={handleModalResponse}
        ctaLeftText={ctaLeftText}
        ctaRightBgColor={ctaRightBgColor}
        ctaRightText={ctaRightText}
        ctaLeftBgColor={ctaLeftBgColor}
        ctaLeftTextColor={ctaLeftTextColor}
        titleBgColor={expandedBgColor}
        ctaRightTextColor={ctaRightTextColor}
        ctaLeftKey={ctaLeftKey}
        ctaRightKey={ctaRightKey}
      />
      {!!expandedText && (
        <Pressable
          testID="cpAvailabilityModal"
          onPress={handleChipViewPress}
          style={[
            styles.pressableContainer,
            { backgroundColor: expandedBgColor, paddingRight: open ? 14 : 20 },
          ]}
        >
          {!!open && (
            <Text style={[styles.expandedText, { color: expandedTextColor }]}>
              {expandedText}
            </Text>
          )}
          <Chevron direction={open ? "right" : "left"} />
        </Pressable>
      )}
    </>
  );
};

const styles = StyleSheet.create({
  pressableContainer: {
    position: "absolute",
    right: 0,
    bottom: 20,
    borderBottomLeftRadius: 20,
    borderTopLeftRadius: 20,
    flexDirection: "row",
    height: 32,
    paddingHorizontal: 14,
    alignItems: "center",
  },
  expandedText: {
    fontFamily: "NotoSansDevanagari-Bold",
    paddingBottom: 4,
    marginRight: 4,
    textAlignVertical: "center",
  },
});

export default ChipView;
